import { CaseReducer, PayloadAction } from '@reduxjs/toolkit';
import isNil from 'lodash/isNil';

import { FILTERS_CACHE_KEY } from 'shared/consts';
import { LocalStorage } from 'tools';
import {
  EArbitrageFilters,
  ECexPairFilters,
  EDexPairFilters,
  EGeneralFilters,
  EProjectFilters,
  ESolPairFilters,
  IFilters,
} from 'types/filters';
import { ICexPair, IDexPair } from 'types/pairs';

import { getProjectFiltersKey } from '../utils';

interface IPayload {
  id: string;
  cex?: {
    pair?: ICexPair;
    type: ECexPairFilters;
  };
  dex?: {
    pair?: IDexPair;
    type: EDexPairFilters;
  };
  sol?: {
    pair?: IDexPair;
    type: ESolPairFilters;
  };
  general?: EGeneralFilters;
  arbitrage?: EArbitrageFilters;
  project?: {
    projectId: number;
    type: EProjectFilters;
  };
}

export const deleteFilterReducer: CaseReducer<IFilters, PayloadAction<IPayload>> = (
  state,
  { payload },
) => {
  const { id, cex, dex, sol, general, arbitrage, project } = payload;

  if (general && state[general]) {
    const newFilters = [...(state[general]!.filters ?? [])].filter(el => el.id !== id);

    state[general]!.filters = newFilters;

    LocalStorage.set(FILTERS_CACHE_KEY, state);
    return;
  }

  if (arbitrage && state.arbitrage[arbitrage]) {
    const newFilters = [...(state.arbitrage[arbitrage]!.filters ?? [])].filter(el => el.id !== id);

    state.arbitrage[arbitrage]!.filters = newFilters;

    LocalStorage.set(FILTERS_CACHE_KEY, state);
    return;
  }

  if (project) {
    const key = getProjectFiltersKey(project.projectId, project.type);
    const projectEntry = state.project[key];
    if (!projectEntry) return;

    state.project[key] = {
      ...projectEntry,
      updated_at: new Date(Date.now()).toISOString(),
      filters: [...projectEntry.filters].filter(el => el.id !== id),
    };

    LocalStorage.set(FILTERS_CACHE_KEY, state);
    return;
  }

  const key = cex ? 'cex' : dex ? 'dex' : 'sol';
  const pairId = cex ? cex.pair?.id : dex ? dex.pair?.id : sol ? sol.pair?.id : undefined;
  const type = cex ? cex.type : dex ? dex.type : sol ? sol.type : undefined;

  if (isNil(pairId) || isNil(type) || !state[key][pairId]) return;

  state[key][pairId]!.updated_at = new Date(Date.now()).toISOString();

  //@ts-ignore
  const newFilters = [...(state[key][pairId]!.filters[type]?.filters ?? [])].filter(
    el => el.id !== id,
  );

  //@ts-ignore
  state[key][pairId]!.filters[type] = {
    filters: newFilters,
    //@ts-ignore
    setted: state[key][pairId]!.filters[type].setted,
  };

  LocalStorage.set(FILTERS_CACHE_KEY, state);
};
